import React, { useEffect } from "react";
import SEO from "../components/SEO";
import FAQ from "../components/FAQ";

const Downloads = () => {
  useEffect(() => {
    // Initialize jQuery-based functionality safely
    if (window.jQuery) {
      const $ = window.jQuery;
      if ($.fn.tab) {
        $(".tab1").tab();
        $(".tab2").tab({ trigger_event_type: "mouseover" });
      }
    }
    window.scrollTo(0, 0);
  }, []);

  const downloadItems = [
    {
      title: "Account Opening form for Individual and Non-Individual",
      file: "/pdf/ACCOUNT_OPENING_FORM_GFSL.pdf",
    },
    {
      title: "Account Closure form",
      file: "/pdf/ACCOUNT_CLOSURE_FORM_GFSL.pdf",
    },
    {
      title: "Modification form",
      file: "/pdf/MODIFICATION_FORM_INDIVISUAL_AND_CORPORATE_GFSL.pdf",
    },
    {
      title: "Reactivation form",
      file: "/pdf/ACCOUNT_REACTIVATION_FORM_GFSL.pdf",
    },
    {
      title: "Nomination form",
      file: "/pdf/NOMINATION_FORM_GFSL.pdf",
    },
    {
      title: "Declaration for Email and Mobile",
      file: "/pdf/DECLARATION_FOR_EMAIL_AND_MOBILE_GFSL.pdf",
    },
    {
      title: "Request letter for issue of instruction book",
      file: "/pdf/REQUEST_LETTER_FOR_ISSUE_OF_INSTRUCTION_BOOK_GFSL.pdf",
    },
    {
      title:
        "Updation of Email IDs, Mobile Number, Aadhar Number and Bank Details",
      file: "/pdf/UPDATION_OF_EMAIL.ID_MOB.NO_ADHAR.NO_BANK.DETAILS_GFSL.pdf",
    },
    {
      title: "Application for change of Signature",
      file: "/pdf/APPLICATION_FOR_CHANGE_OF_SIGNATURE_FORM.pdf",
    },
    {
      title: "Segment Activation Form",
      file: "/pdf/SEGMENT_ACTIVATION_FORM_GFSL.pdf",
    },
    {
      title: "Saral Account Opening Form GFSL",
      file: "/pdf/SARAL_ACCOUNT_OPENING_FORM_GFSL.pdf",
    },
  ];

  return (
    <div className="page-content">
      <SEO
        title="Essential Downloads & Forms"
        description="Access and download essential forms, account opening documents, and regulatory formats. Centralized repository for all Gateway Financial client resources."
      />
      <section id="banner-slider" className="inn-banner-slider">
        <div
          id="carouselExampleIndicators"
          className="carousel slide"
          data-ride="carousel"
        >
          <div className="carousel-inner" role="listbox">
            <div
              className="carousel-item active"
              style={{
                backgroundImage: "url('/images/other-banner.png')",
              }}
            >
              <canvas id="canvas" />
              <div className="carousel-caption">
                <h1>Downloads</h1>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="welcome-section">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-12 text-center">
              <table className="table dwn-tbl table-bordered">
                <thead className="thead-dark">
                  <tr>
                    <th scope="col">Sr. No.</th>
                    <th scope="col" className="text-left">
                      Descriptions
                    </th>
                    <th scope="col">Downloads</th>
                  </tr>
                </thead>
                <tbody>
                  {downloadItems.map((item, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td className="text-left">{item.title}</td>
                      <td>
                        <a
                          href={item.file}
                          target="_blank"
                          rel="noreferrer"
                          aria-label={`Download ${item.title}`}
                        >
                          <i className="fa fa-download" aria-hidden="true" />
                        </a>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </section>

      <section id="app-section">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 align-self-center">
              <h3>Download our Investment Fund App</h3>
              <p>Investing With Gateway Financial Services Limited</p>
              <a href="#download" className="lm-btn">
                Download &amp; Explore More
              </a>
            </div>
            <div className="col-lg-6">
              <img
                src="/images/app-pic.jpg"
                className="img-fluid"
                alt="Mobile App Preview for Gateway Financial"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </section>

      <FAQ />
    </div>
  );
};

export default Downloads;
